import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../../../Edit/Store';
import { SectionContext } from '../../../../../../../Types';
import Store from '../../../../Store';
import { ExperienceResource, ShowUnlicensedToggle } from '../../../../Types';
import ConfirmationButton from './ConfirmationButton';
import CardDescription from './CardDescription';
import OfferingType from '../../../OfferingType';
import ArrowLeftIcon from '../../../../ModalBodySelecting/ArrowLeftIcon';
import { useState } from 'react';
import clsx from 'clsx';

export interface Props {
  store: Store;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  close: () => void;
  resource: ExperienceResource;
}
function Warning({ close, context, learningCollectionStore, resource, store }: Props) {
  const [onOffWarning, setOnOffWarning] = useState<ShowUnlicensedToggle>('show');

  const value = (arg: ShowUnlicensedToggle) => {
    switch (arg) {
      case 'show':
        return false;
      case 'hide':
        return true;
    }
  };

  const handleWarning = () => {
    switch (onOffWarning) {
      case 'show':
        setOnOffWarning('hide');
        break;
      case 'hide':
        setOnOffWarning('show');
        break;
    }
  };
  return (
    <div className="px-11 py-5">
      <div className="flex items-center ">
        <div className="w-[20px] h-[20px] cursor-pointer" onClick={close}>
          <ArrowLeftIcon />
        </div>
        <div className="font-semibold text-xl pl-4">
          <T kind='Adding "{{name}}"' name={resource.payload.title.text} />
        </div>
      </div>
      <div className="flex p-6 items-start mt-8	gap-6 rounded-md border border-gray-200 bg-gray-10 w-[55%] flex flex-col">
        <p className="text-gray-900 text-xl font-medium">
          <T kind="You don’t have enough licenses for this program type" />
        </p>
        <div
          className={clsx('opacity-1', { 'opacity-70': resource.payload.status === 'Unlicensed' })}
        >
          <OfferingType resource={resource} />
        </div>
        <CardDescription />
        <div className="flex flex-row items-center pr-5">
          <input
            className="h-5 w-5 text-teal-600 rounded-sm"
            type="checkbox"
            checked={value(onOffWarning)}
            onChange={handleWarning}
          />
          <h5 className="ml-8">
            <T kind="Do not show me this message again" />
          </h5>
        </div>
      </div>
      <ConfirmationButton
        store={store}
        learningCollectionStore={learningCollectionStore}
        context={context}
        resource={resource}
        close={close}
        onOffWarning={onOffWarning}
      />
    </div>
  );
}

export default observer(Warning);
